<template>
  <div>
    <div class="d-flex ">
      <div class="side-frame"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          {{ $l('form_label_class_level') || '层级' }}：{{
            formData.classLevel ? formData.classLevel : '1'
          }}
          {{ $l('form_label_level') || '级' }}
        </span>
        <el-divider direction="vertical"></el-divider>

        <el-tag
          size="mini"
          :type="formData.categoryStatus === 'Y' ? 'success' : 'danger'"
        >
          {{
            formData.categoryStatusName
              ? formData.categoryStatusName
              : $l('INDEX.form_label_valid') || '有效'
          }}
        </el-tag>

        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          {{ $l('form_label_category_parent') || '上级分类' }}：{{
            formData.parentName ? formData.parentName : orgRow.categoryName
          }}
        </span>
      </div>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_category_no') || '分类编码'"
            prop="categoryNo"
          >
            <el-input
              clearable
              v-model="formData.categoryNo"
              maxlength="20"
              :placeholder="$l('form_label_pe_category_no') || '请输入分类编号'"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_is_last') || '是否末级'"
            prop="isLast"
          >
            <el-select
              v-model="formData.isLast"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              filterable
              clearable
              style="width:100%"
            >
              <el-option
                value="Y"
                :label="$l('form_label_is_last_yes') || '是'"
              ></el-option>
              <el-option
                value="N"
                :label="$l('form_label_is_last_no') || '否'"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_category_name') || '中文'"
            prop="categoryName"
          >
            <el-input
              clearable
              v-model="formData.categoryName"
              maxlength="200"
              :placeholder="
                $l('form_label_pe_category_name') || '请输入中文名称'
              "
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_category_name_en') || '英文名称'"
            prop="categoryNameEn"
          >
            <el-input
              clearable
              v-model="formData.categoryNameEn"
              maxlength="200"
              :placeholder="
                $l('form_label_pe_category_name_en') || '请输入英文名称'
              "
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_has_E-commerce_brand') || '是否亚马逊使用'"
            prop="isEcom"
          >
            <el-select
              v-model="formData.isEcom"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              filterable
              clearable
              style="width:100%"
            >
              <el-option
                value="Y"
                :label="$l('form_label_is_last_yes') || '是'"
              ></el-option>
              <el-option
                value="N"
                :label="$l('form_label_is_last_no') || '否'"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="d-flex align-items-center mt-2">
      <span style="font-size: 14px; color: #606266">
        Modify：{{ formData.modifyBy || '--' }} at
        {{ formData.modifyDate || '--' }}
      </span>
    </div>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    isadd: Boolean, //是否为添加功能
    categoryCode: String,
    orgRow: {
      type: Object,
      default: () => {},
    },
    parentDep: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      regionShow: false,
      formData: {
        isLast: 'Y',
        categoryStatus: 'Y',
        classLevel: 0,
        isEcom: 'N',
      },
      rules: {
        categoryNo: [
          {
            required: true,
            message: this.$l('form_label_pe_category_no') || '请输入分类编号',
            trigger: 'blur',
          },
        ],
        categoryName: [
          {
            required: true,
            message: this.$l('form_label_pe_category_name') || '请输入分类名称',
            trigger: 'blur',
          },
        ],
        categoryNameEn: [
          {
            required: true,
            message:
              this.$l('form_label_pe_category_name_en') || '请输入分类英文名称',
            trigger: 'blur',
          },
        ],
        classLevel: [
          {
            required: false,
            message: '请输入层级',
            trigger: 'blur',
          },
        ],
        isLast: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        isEcom: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        categoryStatus: [
          {
            required: false,
            message: '有效标志',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    //console.log(typeof this.orgRow.classLevel)
    //console.log(this.formData.classLevel)
    if (this.isadd) {
      this.formData.classLevel = parseInt(this.orgRow.classLevel) + 1
    }
    //console.log(this.formData.classLevel)
    this.getData()
    this.regionShow = true
  },
  methods: {
    getData() {
      //console.log("run1")
      if (!this.categoryCode) return
      //console.log("run2")
      this.$api
        .masCategoryDetailApi({
          categoryCode: this.categoryCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      let params = { ...this.formData }
      if (!this.categoryCode) {
        const { categoryCode } = this.orgRow
        if (categoryCode) {
          params = {
            ...this.formData,
            parentCode: categoryCode,
            masterCategoryCode: categoryCode,
          }
        }
      }
      this.loadingOpen()
      this.$api
        .masCategorySaveApi(params)
        .then(() => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存',
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    },
    toUppercase(e) {
      return e.replace(/[^A-z]*/g, '').toLocaleUpperCase()
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 1px;
}
</style>
